export class UserUpdate
{
    storeid: string;
    accounttype: string;
    userstore: string;
    role: string;
}


// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/userupdatemodel.ts